module.exports = __webpack_public_path__ + "img/cross.25e2b2e2.svg";